// third-party
import { FormattedMessage } from "react-intl";

// assets
import { KyberNetwork, Setting3 } from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  applications: KyberNetwork,
  profile: Setting3,
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const applications: NavItemType = {
  id: "group-applications",
  title: <FormattedMessage id="page.menu_items_applications_settings_label" />,
  icon: icons.applications,
  type: "group",
  children: [
    {
      id: "user-profile",
      title: (
        <FormattedMessage id="page.menu_items_applications_settings_profile_label" />
      ),
      type: "item",
      url: "/user/personal",
      icon: icons.profile,
    },
  ],
};

export default applications;
